export const TIME_PERIOD = 86400000;
export const AVATAR_SIZE = 24;

export const DEFAULT_SORT_FIELD = 'title';
export const DEFAULT_SORT_ORDER = 'ascending';

export const SORT_FIELD_OPTIONS = [
  { value: 'title', label: 'title' },
  { value: 'due', label: 'due_date' },
  { value: 'createdAt', label: 'created_date' },
  { value: 'storyPoints', label: 'story_points' },
];

export const ASSIGNEE_FILTER_PLACEHOLDER = 'assignees';
export const STORY_POINTS_UNIT = 'pts';
export const DEFAULT_STORY_POINTS = 0;

export const REFERENCE_LABEL = 'reference';
export const TASK_FIELD_EMPTY_PLACEHOLDER = '-';
export const TASK_SPRINT_FETCH_LIMIT = 50;
